import { IconLogoColor } from '@application/Interfaces/Images/IconLogoColor'
import { IconWhiteLogo } from '@application/Interfaces/Images/IconWhiteLogo'

export const IcontainerLogos = {
    logoWhite: IconWhiteLogo,
    logoColor: IconLogoColor,
}
